module.exports = __webpack_public_path__ + "img/mac-download.683ced73.webp";